import { render, staticRenderFns } from "./DayDivider.vue?vue&type=template&id=8abc0538&scoped=true&"
import script from "./DayDivider.vue?vue&type=script&lang=js&"
export * from "./DayDivider.vue?vue&type=script&lang=js&"
import style0 from "./DayDivider.vue?vue&type=style&index=0&id=8abc0538&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abc0538",
  null
  
)

export default component.exports